module.exports = __webpack_public_path__ + "static/media/Inter-SemiBold.2c20857c.woff2";